module.exports = __webpack_public_path__ + "static/media/NewYork1.af99fc5b.jpeg";